var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4111 13.3313C14.4111 13.6319 14.1878 13.8803 13.898 13.9196L13.8174 13.925H3.03664C2.70872 13.925 2.44289 13.6592 2.44289 13.3313C2.44289 13.0307 2.66626 12.7823 2.95607 12.743L3.03664 12.7375H13.8174C14.1453 12.7375 14.4111 13.0034 14.4111 13.3313Z",
    fill: "#2653F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69817 16.1387C6.93058 16.37 6.93145 16.746 6.70011 16.9784C6.4898 17.1897 6.15999 17.2096 5.92715 17.0377L5.86042 16.9803L2.61723 13.7521C2.40526 13.5411 2.38599 13.21 2.55942 12.9771L2.61723 12.9105L5.86042 9.68221C6.09283 9.45088 6.46877 9.45174 6.70011 9.68415C6.91042 9.89543 6.92882 10.2253 6.75581 10.4574L6.69817 10.5238L3.87826 13.3309L6.69817 16.1387Z",
    fill: "#2653F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5593 5.47131C16.5593 5.77191 16.336 6.02033 16.0461 6.05964L15.9656 6.06506L5.18484 6.06506C4.85692 6.06506 4.59109 5.79923 4.59109 5.47131C4.59109 5.17072 4.81446 4.9223 5.10427 4.88298L5.18484 4.87756L15.9656 4.87756C16.2935 4.87756 16.5593 5.14339 16.5593 5.47131Z",
    fill: "#5E7799"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3849 5.05059C16.5969 5.26159 16.6162 5.5927 16.4427 5.82553L16.3849 5.89222L13.1417 9.12046C12.9093 9.3518 12.5334 9.35093 12.3021 9.11852C12.0917 8.90724 12.0733 8.57734 12.2464 8.34529L12.304 8.27883L15.1248 5.47123L12.304 2.66398C12.0927 2.45367 12.0728 2.12386 12.2447 1.89102L12.3021 1.82429C12.5124 1.61301 12.8422 1.59308 13.075 1.76502L13.1417 1.82235L16.3849 5.05059Z",
    fill: "#5E7799"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIn);
export default __webpack_public_path__ + "static/media/transferIn.9ed82d5342caa07f787ce101145c1397.svg";
export { ForwardRef as ReactComponent };